import { clipboardConfig } from "./config";
import { indexedDbCopies, memoryCopies } from "./store";
import { browserClipboard } from "./system";
import { TabClipboard } from "./tab-clipboard";

export { pasteShortcut } from "./paste";
export type { ClipboardEngine, EngineCopy } from "./tab-clipboard";
export { TabClipboard } from "./tab-clipboard";

let shared: TabClipboard | undefined;

/** The tab's clipboard across the person's tabs (`tab-clipboard.ts`), made on first use. */
export function tabClipboard(): TabClipboard {
  shared ??= new TabClipboard({
    store: typeof indexedDB === "undefined" ? memoryCopies() : indexedDbCopies(),
    channel:
      typeof BroadcastChannel === "undefined"
        ? undefined
        : new BroadcastChannel(clipboardConfig.channel),
    system: browserClipboard(),
    now: () => Date.now(),
    warn: (message, error) => console.warn(message, error),
  });
  return shared;
}
